/**
 * Scanner Configuration Utility
 * Mengelola konfigurasi perangkat Barcode Scanner (USB HID, Bluetooth, & Capacitor APK)
 */

export const SCANNER_MODES = [
  {
    id: "usb_hid",
    name: "USB / Bluetooth HID Keyboard (Standard)",
    desc: "Untuk scanner kabel USB atau Bluetooth handheld yang bertindak sebagai input keyboard fisik (emulasi nirkabel/kabel).",
  },
  {
    id: "web_bluetooth",
    name: "Web Bluetooth API Direct",
    desc: "Koneksi nirkabel langsung via browser Web Bluetooth API (memerlukan browser yang mendukung Web Bluetooth).",
  },
  {
    id: "capacitor_apk",
    name: "Capacitor Native Mobile Scanner (APK)",
    desc: "Integrasi sensor kamera / hardware scanner khusus pada aplikasi Android/iOS Capacitor Ionic.",
  },
];

const DEFAULT_CONFIG = {
  deviceName: "",
  activeDeviceId: "",
  mode: "usb_hid",
  autoAddToCart: true,
  beepOnScan: true,
  enterSuffix: true,
  minBarcodeLength: 3,
  maxInterKeyTimeoutMs: 50,
  savedDevices: [],
};

export function getScannerConfig() {
  try {
    const saved = localStorage.getItem("barcode_scanner_config");
    if (saved) {
      const parsed = JSON.parse(saved);
      return {
        ...DEFAULT_CONFIG,
        ...parsed,
        savedDevices: parsed.savedDevices || [],
      };
    }
  } catch (e) {
    console.error("Failed to parse scanner config:", e);
  }
  return DEFAULT_CONFIG;
}

export function setScannerConfig(config) {
  try {
    const updated = { ...getScannerConfig(), ...config };
    localStorage.setItem("barcode_scanner_config", JSON.stringify(updated));
    window.dispatchEvent(new CustomEvent("scannerConfigUpdated", { detail: updated }));
    return updated;
  } catch (e) {
    console.error("Failed to save scanner config:", e);
    return getScannerConfig();
  }
}

/**
 * Play pleasant scan beep sound if enabled
 */
export function playScanBeep() {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    
    osc.type = "sine";
    osc.frequency.setValueAtTime(1400, ctx.currentTime);
    osc.frequency.exponentialRampToValueAtTime(800, ctx.currentTime + 0.08);
    
    gain.gain.setValueAtTime(0.15, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.08);
    
    osc.connect(gain);
    gain.connect(ctx.destination);
    
    osc.start();
    osc.stop(ctx.currentTime + 0.08);
  } catch (_) {
    // Silent fail if audio context blocked
  }
}
